import { createContext, useContext, useState } from "react";

interface DeleteUserContextType {
  deleteUserId: string | null;
  setDeleteUserId: (userId: string | null) => void;
}

const DeleteUserContext = createContext<DeleteUserContextType | undefined>(
  undefined,
);

export const DeleteUserProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [deleteUserId, setDeleteUserId] = useState<string | null>(null);

  return (
    <DeleteUserContext.Provider value={{ deleteUserId, setDeleteUserId }}>
      {children}
    </DeleteUserContext.Provider>
  );
};

export const useDeleteUser = () => {
  const context = useContext(DeleteUserContext);
  if (!context) {
    throw new Error("useDeleteUser must be used within DeleteUserProvider");
  }
  return context;
};
